import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  // baseURL:'http://118.31.113.132:21001/',
  // baseURL:'http://192.168.10.119:8081',
  baseURL:'https://alipay.we.api.yisusc.com:8443/',
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if (config.url.includes('/order/importList')) {
    config.headers['content-type'] = 'multipart/form-data'
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    // console.log('response', response)
    
    const res = response.data
    if (res.code !== 200) {
      if(response.request.responseURL.includes('/order/exportList')) {
        return response;
      }
      if(response.request.responseURL.includes('/order/importList')) {
        return response;
      }

      if(res.message.includes('alipay_open_mini_')) {
        let errInfo = JSON.parse(res.message);
        let key = Object.keys(errInfo).filter(ele => ele.includes('alipay_open_mini_'))[0];
        Message({
          message: errInfo[key].sub_msg,
          type: 'error',
          duration: 3 * 1000
        })
        return Promise.reject('error')
      }

      // if(res.message.includes('alipay_open_mini_version_upload_response')) {
      //   let errInfo = JSON.parse(res.message);
      //   Message({
      //     message: errInfo.alipay_open_mini_version_upload_response.sub_msg,
      //     type: 'error',
      //     duration: 3 * 1000
      //   })
      //   return Promise.reject('error')
      // }
      // if(res.message.includes('alipay_open_mini_experience_create_response')) {
      //   let errInfo = JSON.parse(res.message);
      //   Message({
      //     message: errInfo.alipay_open_mini_experience_create_response.sub_msg,
      //     type: 'error',
      //     duration: 3 * 1000
      //   })
      //   return Promise.reject('error')
      // }
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js